<template>
  <div class="wapBottom">
    <div class="wap-bottom-logo">
      <img class="wap-logo" src="../assets/logo_2@2x.png" :alt="isEnglish ? 'Chun Yang Tai Logo' : '春阳台logo'" />
    </div>
    <div class="wap-line"></div>

    <div class="wap-bottom-info">
      <div
        class="links"
        :class="showInfo ? 'showCopyright' : 'hideCopyright'"
        @click="showInfo = !showInfo"
      >
        {{ isEnglish ? 'About Us' : '联系我们' }}
      </div>
      <div class="copyright" v-if="showInfo">
        <div>{{ currentContactInfo.address }}</div>
        <div>{{ currentContactInfo.phone }}</div>
        <div>
          {{ isEnglish ? 'Email: ' : '邮箱：' }}
          <a href="mailto:chunyangtai@langchuanculture.cn" class="email-link">
            chunyangtai@langchuanculture.cn
          </a>
        </div>
      </div>
    </div>
    <div class="wap-line"></div>
    
    <div class="wap-bottom-info">
      <div
        class="links"
        :class="showContact ? 'showCopyright' : 'hideCopyright'"
        @click="showContact = !showContact"
      >
        {{ isEnglish ? 'Contact Us' : '关注我们' }}
      </div>

      <div class="wap-qr-list" v-if="showContact">
        <img class="show-wap-qr" src="../assets/wap-cyt.png" :alt="isEnglish ? 'Official Account QR Code' : '公众号二维码'" />
        <img class="show-wap-qr" src="../assets/wap-xcx.png" :alt="isEnglish ? 'Mini Program QR Code' : '小程序二维码'" />
        <img class="show-wap-qr" src="../assets/wap-xhs.png" :alt="isEnglish ? 'Xiaohongshu QR Code' : '小红书二维码'" />
      </div>
    </div>
    <div class="wap-line"></div>

    <div class="bottom-certificate">
      <a
        href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
        target="_blank"
        rel="noopener noreferrer"
      >
        ©️2024 CHUN YANG TAI 粤ICP备2023112445号
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WapBottom',
  
  data() {
    return {
      lan: this.$store.state.isEn,
      showInfo: false,
      showContact: false,
      contactInfoData: {
        cn: {
          address: '地址：广州市花都区炭步镇朗头村青云路18号',
          phone: '电话：020-22262888'
        },
        en: {
          address: 'Add: NO.18 Qingyun Road, Langtou Village,Tanbu Town, Huadu District, Guangzhou, China',
          phone: 'Tel: 020-22262888'
        }
      }
    };
  },
  
  computed: {
    isEnglish() {
      return this.lan === 1;
    },
    
    currentContactInfo() {
      return this.isEnglish ? this.contactInfoData.en : this.contactInfoData.cn;
    }
  },
  
  watch: {
    "$store.state.isEn"(newVal) {
      this.lan = newVal;
    },
  },
};
</script>

<style scoped>
.wapBottom {
  width: 100%;
  z-index: 100;
  background-color: #000;
  background-size: cover;
  min-width: 320px;
}

.wap-bottom-logo {
  padding-top: 30px;
  margin: 0 auto 20px;
  width: 90%;
}

.wap-logo {
  width: 94px;
  height: 36px;
}

.wap-line {
  margin: 0 auto;
  width: 90%;
  height: 1px;
  background-color: #646464;
}

.wap-bottom-info {
  width: 90%;
  margin: 25px auto;
}

.links {
  position: relative;
  font-size: 16px;
  color: #fff;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
  cursor: pointer;
}

.copyright {
  padding-top: 20px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #fff;
  line-height: 28px;
  font-weight: 400;
}
.copyright a{
  padding-top: 20px;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #E3B389;
  line-height: 28px;
  font-weight: 400;
}

.email-link {
  color: #E3B389;
  font-size: 14px;
  text-decoration: underline;
}

.email-link:hover {
  color: #E3B389;
}

.hideCopyright::after {
  content: "";
  position: absolute;
  top: 30%;
  right: 2px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666;
  border-right: 2px solid #666;
  transform: translateY(-45%) rotate(135deg);
}

.showCopyright::after {
  content: "";
  position: absolute;
  top: 30%;
  right: 2px;
  width: 8px;
  height: 8px;
  border-bottom: 2px solid #666;
  border-left: 2px solid #666;
  transform: translateY(45%) rotate(135deg);
}

.wap-qr-list {
  width: 100%;
  text-align: center;
}

.show-wap-qr {
  width: 25%;
  object-fit: contain;
  margin: 0 10px;
  margin-top: 60px;
}

.show-wap-qr-title {
  display: flex;
  justify-content: center;
  margin: 20px auto 0;
  color: #fff;
  line-height: 28px;
}

.show-wap-qr-title img {
  width: 28px;
  height: 28px;
  margin-right: 12px;
}

.bottom-certificate {
  padding: 30px 0;
  display: flex;
  justify-content: center;
  width: 98%;
}

.bottom-certificate a {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #98989f;
  font-weight: normal;
  text-decoration: none;
}

.bottom-certificate a:hover {
  text-decoration: underline;
}

@media (max-width: 450px) {
  .wap-bottom-logo {
    padding-top: 25px;
    margin: 0 auto 16px;
    width: 90%;
  }
  
  .wap-logo {
    width: 70px;
    height: 29px;
  }
  
  .wap-bottom-info {
    width: 90%;
    margin: 17px auto;
  }

  .links {
    font-size: 14px;
  }
  
  .bottom-certificate a {
    font-size: 12px;
  }
  
  .copyright {
    font-size: 12px;
  }
  
  .wap-qr-list {
    width: 60%;
    margin: 0 auto;
    text-align: center;
  }
  
  .show-wap-qr {
    width: 115px;
    height: 145px;
    object-fit: contain;
    margin-top: 31px;
  }
}
</style>